import { render, staticRenderFns } from "./page-navbar.vue?vue&type=template&id=f736cce0"
import script from "./page-navbar.vue?vue&type=script&lang=js"
export * from "./page-navbar.vue?vue&type=script&lang=js"
import style0 from "./page-navbar.vue?vue&type=style&index=0&id=f736cce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports